export const DRAGGABLE_TYPE_UMO = 'DRAGGABLE_TYPE_UMO';

export const DRAGGABLE_ORIGIN_UMO_GALLERY = 'DRAGGABLE_ORIGIN_UMO_GALLERY';
export const DRAGGABLE_ORIGIN_UMO_GALLERY_WORKSPACE = 'DRAGGABLE_ORIGIN_UMO_GALLERY_WORKSPACE';
export const DRAGGABLE_ORIGIN_WORKSPACE_PREVIEW = 'DRAGGABLE_ORIGIN_WORKSPACE_PREVIEW';

export const DRAGGABLE_ERROR_INVALID_ORIGIN = 'Invalid draggable origin';
export const DRAGGABLE_ERROR_INVALID_TYPE = 'Invalid draggable type';
